import { message } from 'antd';
import { AttachmentsAPI } from 'api/attachments';

export const handleDownload = (
  _id: number | undefined,
  errorText = '',
): void => {
  if (!_id) {
    return;
  }
  AttachmentsAPI.getAttachment(_id).then(
    (attachment) => {
      const $a = document.createElement('a');
      const downloadUrl = attachment.downloadUrl || attachment.location || '';

      $a.href = downloadUrl;
      $a.download = downloadUrl;
      $a.target = '_blank';
      document.body.appendChild($a);
      $a.click();
      document.body.removeChild($a);
    },
    () => {
      message.error(errorText);
    },
  );
};
